module.exports = __webpack_public_path__ + "static/media/s.sky11.c1c40d8b.svg";